module.exports = __webpack_public_path__ + "assets/images/JMDC1.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/JMDC1.png
// module id = 1398
// module chunks = 1